import { render, staticRenderFns } from "./ListarListas.vue?vue&type=template&id=1386bf2a&"
import script from "./ListarListas.vue?vue&type=script&lang=js&"
export * from "./ListarListas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports